import { WebUser } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";

export class RobeSupportFilesUsers {
  private core: XcoreCore;

  constructor(core: XcoreCore) {
    this.core = core;
  }

  public list(params: string) {
    return this.core
      .fetch("/api/web/users" + params)
      .then((res) => res.json().then((d) => [d as WebUser[], res.headers.get("content-range")!] as const));
  }

  public single(id: number) {
    return this.core.fetch(`/api/web/users/${id}`).then<WebUser>((r) => r.json());
  }

  public edit({ password, ...user }: WebUser) {
    return this.core.fetch("/api/web/users", {
      method: "PUT",
      body: JSON.stringify(password === "" ? user : { ...user, password }),
    });
  }

  public addUserToGroups(user: number, groups: number[]) {
    return this.core.fetch(`/api/web/users/${user}/group`, {
      method: "POST",
      body: JSON.stringify(groups),
    });
  }

  public removeUserFromGroups(user: number, groups: number[]) {
    return this.core.fetch(`/api/web/users/${user}/group${parseQueryParamsObject({ ids: groups })}`, {
      method: "DELETE",
    });
  }

  public delete(ids: number[]) {
    return this.core.fetch(`/api/web/users${parseQueryParamsObject({ ids })}`, { method: "DELETE" });
  }
}
